import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    dot: {
        width: '12px',
        height: '12px',
        backgroundColor: '#14b8a6',
        borderRadius: '50%',
    },
}));

export const TimelineDot: React.FC = () => {
    const classes = useStyles();
    return <Box className={classes.dot} />;
};
